
export default {
  // Contact Page
  contactUsTitle: "Contact Us",
  contactUsDesc: "Get in touch with our team for any inquiries or support",
  name: "Name",
  contactEmail: "Email",
  message: "Message",
  yourName: "Your Name",
  yourEmail: "Your Email",
  howCanWeHelp: "How can we help?",
  send: "Send",
  sending: "Sending...",
  downloadCampaignGuide: "Download Campaign Guide",
  downloading: "Downloading...",
  
  // Contact Page Additional
  getInTouch: "Get In Touch",
  email: "Email",
  location: "Location",
  sendMessage: "Send us a Message",
  readyToStart: "Ready to start your digital advertising journey? Let's discuss your goals and create something amazing together.",
  messageSentTitle: "Message sent successfully",
  messageSentDesc: "We'll get back to you as soon as possible.",
  messageErrorTitle: "Error sending message",
  messageErrorDesc: "Please try again later.",
} as const;
